import { createFileRoute, redirect } from '@tanstack/react-router';

import { redirectAuthenticatedToDashboard } from '~/lib/route-auth';

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    await redirectAuthenticatedToDashboard();
    throw redirect({ to: '/login' });
  },
  component: () => null
});
